import type {DataExtensions} from '../types';
import {
  QualifiedMap,
  qualify,
  type Qualified,
} from '@packages/systems/wfdl-Qualified';
import {Plugins, Component} from '@packages/systems/wfdl';

import {getDataExtension as dynamoWrapperExtension} from './cms/DynamoWrapper';
import {getDataExtension as searchResultWrapperExtension} from './search/SearchResultWrapper';
import {getDataExtension as commerceOrderConfirmationContainerExtension} from './ecommerce/CommerceOrderConfirmationContainer';

const dynamoWrapperType = qualify(
  Plugins.name('Dynamo'),
  Component.name('DynamoWrapper')
);
const searchResultWrapperType = qualify(
  Plugins.name('Search'),
  Component.name('SearchResultWrapper')
);

const commerceOrderConfirmationContainerType = qualify(
  Plugins.name('Commerce'),
  Component.name('CommerceOrderConfirmationContainer')
);

const fromEntries = <key extends string, value>(
  entries: Array<[Qualified<key>, value]>
): QualifiedMap<key, value> => {
  return entries.reduce<QualifiedMap<key, value>>(
    (qMap, [qName, val]) => qMap.set(qName, val),
    QualifiedMap.empty()
  );
};

export const dataExtensions: DataExtensions = fromEntries([
  [dynamoWrapperType, dynamoWrapperExtension],
  [searchResultWrapperType, searchResultWrapperExtension],
  [
    commerceOrderConfirmationContainerType,
    commerceOrderConfirmationContainerExtension,
  ],
]);
